export default __webpack_public_path__ + "static/media/join_icon.1a5a169c.svg";